import React, {useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import s from './ReviewList.module.scss';
import ReviewSummary from './ReviewSummary';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Loading from '../../components/Loading/Loading';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import titleImage from "../../assets/images/titleImage.png";

const ReviewItem = ({ review }) => (
  <div className={s.reviewItem}>
    <div className={s.evaluation}>
      <span>{'★'.repeat(review.rating)}{ '☆'.repeat(5 - review.rating) }</span>
    </div>
    <ul className={s.tags}>
      <li>{review.ageGroup}</li>
      <li>{review.gender}</li>
      <li>{review.travelerType}</li>
    </ul>
    <div className={s.date}>投稿日：{review.date}</div>
    <h2 className={s.title}>{review.title}</h2>
    <div className={s.content}>{review.content}</div>
  </div>
);

const ReviewList = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { rezdyId } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const refreshReviews = async () => {
    if (data) {
      const response = await fetch(`${apiUrl}/api/review/${rezdyId}`);
      if (response.ok) {
        const updatedData = await response.json();
        setData(updatedData);
      } else {
        console.error('Failed to fetch updated reviews');
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  useEffect(() => {
    const fetchReviews = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/review/${rezdyId}`);
        const data = await response.json();
        if (response.ok) {
          setData(data);
        } else {
          console.error(data.error);
        }
      } catch (error) {
        console.error('Error fetching reviews:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [rezdyId]);

  if (loading) {
    return (
      <div className={s.container}>
        <Loading loading={loading} />
      </div>
    );
  }
  const breadcrumbItems = [
    { name: 'ホーム ', link: '/' },
    { name: data.tour.title, link: `/tours/${rezdyId}` },
    { name: 'Reviews'}
  ];
  return (

    <>
          <Helmet>
        <title>口コミ一覧 – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
        <meta property="og:title" content="口コミ一覧 – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
      </Helmet>
    <div className={s.root}>
      <div className={"row mt-3"}>
        <div className={"col-12"}>
          <Breadcrumb items={breadcrumbItems}/>
          <div className={s.titleContainer}>
            <h2><img className={s.titleImage} src={titleImage}/>{data.tour.title}</h2>
          </div>
        </div>
      </div>


      <ReviewSummary
        data={data.tour}
        reviews={data.reviews}
        onReviewSubmitted={refreshReviews}
        className={s.reviewSummary}
        isList={true} />
    </div>
    </>
  )
}


export default ReviewList;
